
export const InitialAttachmentsDict = {
    PrzeniesienieWZ: {
        zgoda: {
            label: 'Zgoda strony, dla której została wydana decyzja o warunkach zabudowy, na jej przeniesienie na rzecz innego podmiotu.',
            required: true,
            multiple: false,
            description: '',
        },
        pelnomocnictwo: {
            label: 'Dokument stwierdzający udzielenie pełnomocnictwa (jeśli został ustanowiony pełnomocnik).',
            required: false,
            multiple: false,
            description: '',
        },
    },
    ZmianaWZ: {
        zgoda: {
            label: 'Zgoda stron na zmianę decyzji o warunkach zabudowy (jeśli jest wymagana).',
            required: false,
            multiple: false,
            description: '',
        },
        pelnomocnictwo: {
            label: 'Dokument pełnomocnictwa (jeśli został ustanowiony pełnomocnik).',
            required: false,
            multiple: false,
            description: '',
        },
        pelnomocnictwoOplata: {
            label: 'Dowód uiszczenia opłaty skarbowej z tytułu udzielenia pełnomocnictwa (jeśli został ustanowiony pełnomocnik).',
            required: false,
            multiple: false,
            description: '',
        },
        inne: {
            label: 'Inne załączniki (jeśli są wymagane).',
            required: false,
            multiple: true,
            description: '',
        },
    },
    WnOpiniaPodzialu: {
        tytul: {
            label: 'Dokument stwierdzający tytuł prawny do nieruchomości.',
            required: true,
            multiple: false,
            description: '',
        },
        wypis: {
            label: 'Wypis z katastru nieruchomości i kopię mapy katastralnej obejmującej nieruchomość podlegającą podziałowi.',
            required: true,
            multiple: false,
            description: '',
        },
            projekt: {
            label: 'Wstępny projekt podziału nieruchomości.',
            required: true,
            multiple: false,
            description: '',
        },
            pelnomocnictwo: {
            label: 'Kopia prawomocnej decyzji o warunkach zabudowy i zagospodarowania terenu (jeśli dotyczy).',
            required: false,
            multiple: false,
            description: '',
        },
    }
}

const rodzajOptions = [
  {
    label: 'Zbiornik bezodpływowy (szambo)',
    value: 'Zbiornik bezodpływowy (szambo)',
    state: 'rodzaj',
  },
  {
    label: 'Przydomowa oczyszczalnia ścieków',
    value: 'Przydomowa oczyszczalnia ścieków',
    state: 'rodzaj',
  },
];

const dzialalnoscOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'dzialalnosc',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'dzialalnosc',
  },
];

const wodaOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'woda',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'woda',
  },
];

const umowaOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'umowa',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'umowa',
  },
];

export const infoDict = {
    PrzeniesienieWZ: {
        NrDecyzji: {
            label: 'Numer decyzji:',
            editable: true,
        },
        data: {
            label: 'Data wydania decyzji:',
            editable: true,
        },
        znakSprawy: {
            label: 'Znak sprawy:',
            editable: true,
        },
        nazwa: {
            label: 'Nazwa i rodzaj zamierzenia inwestycyjnego, którego dotyczy decyzja, charakterystyka inwestycji:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
        adres: {
            label: 'Adres zamierzenia inwestycyjnego:',
            editable: true,
            type: 'textarea',
            rows: 3,
        },
    },
    ZmianaWZ: {
        NrDecyzji: {
            label: 'Numer decyzji:',
            editable: true,
        },
        data: {
            label: 'Data wydania decyzji:',
            editable: true,
        },
        znakSprawy: {
            label: 'Znak sprawy:',
            editable: true,
        },
        nazwa: {
            label: 'Nazwa i rodzaj zamierzenia inwestycyjnego, którego dotyczy decyzja, charakterystyka inwestycji:',
            editable: true,
            type: 'textarea',
            rows: 5,
        },
        adres: {
            label: 'Adres zamierzenia inwestycyjnego:',
            editable: true,
            type: 'textarea',
            rows: 3,
        },
        zakres: {
            label: 'Zakres wnioskowanych zmian w decyzji o warunkach zabudowy: ',
            editable: true,
            type: 'textarea',
            rows: 3,
        },
    },
    WnOpiniaPodzialu: {
        NrKW: {
            label: 'Numer księgi wieczystej KW:',
            editable: true,
        },
        NrDzialek: {
            label: 'Numery działek w wyniku podziału:',
            editable: true,
        },
        celPodzialu: {
            label: 'Cel dokonania podziału nieruchomości:',
            editable: true,
        },
    },
    ZgloszenieEwPOS: {
        rodzaj: {
            label: 'Rodzaj urządzenia:',
            editable: true,
            type: 'Select',
            options: rodzajOptions
        },
        adres: {
            label: 'Adres nieruchomości ze zgłaszanym urządzeniem:',
            editable: true,
        },
        liczbaOs: {
            label: 'Liczba osób zamieszkujących posesję:',
            editable: true,
        },
        dzialalnosc: {
            label: 'Czy na nieruchomości prowadzona jest zarejestrowana działalność gospodarcza:',
            editable: true,
            type: 'Select',
            options: dzialalnoscOptions
        },
        woda: {
            label: 'Czy nieruchomość zaopatrywana jest w wodę z innego źródła niż wodociąg miejski (studnia głębinowa):',
            editable: true,
            type: 'Select',
            options: wodaOptions
        },
        pojemnosc: {
            label: 'Pojemność urządzenia [m3]:',
            editable: true,
        },
        umowa: {
            label: 'Czy jest podpisana umowa z firmą asenizacyjną na opróżnianie zbiornika bezodpływowego/ osadnika i transport nieczystości ciekłych do stacji zlewnej:',
            editable: true,
            type: 'Select',
            options: umowaOptions
        },
        umowaData: {
            label: 'Data zawarcia umowy:',
            editable: true,
        },
        umowaFirma: {
            label: 'Nazwa i adres firmy świadczącej usługę opróżniania zbiorników/osadników oraz transportu nieczystości ciekłych:',
            editable: true,
            type: 'textarea',
            rows: 3
        },
        czestotliwosc: {
            label: 'Częstotliwość opróżniania:',
            editable: true,
        },
        infoDod: {
            label: 'Dodatkowe informacje (np. dotyczące współwłaścicieli, współużytkowników nieruchomości lub większej liczby zbiorników bezodpływowych):',
            editable: true,
            type: 'textarea',
            rows: 5
        },
    }
}

export const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const nextStep = '/eservices/eserviceSummary/';

export const redirectToSummary = (jobId) => {
    window.location.href = `${nextStep}${jobId}`;
};


// WEBPACK FOOTER //
// src/routes/eservices/constants.js